export const directLabsCheckout = {
  loading: "Loading checkout details",
  authStart: {
    title: "First, let's confirm that {{itemName}} is available in your area:",
    titleFallback: "First, let's confirm this lab is available in your area:",
    description: "Enter your email to sign in or create your Fullscript account.",
    emailLabel: "Email address",
    zipCodeLabel: "Zip code",
    locationNote: "Availability based on location",
    continueButton: "Continue",
    errors: {
      emailInvalid: "Please enter a valid email address",
      zipInvalid: "Please enter a valid zip code",
      generalError: "Something went wrong. Please try again.",
      recaptchaError: "reCAPTCHA verification failed. Please try again.",
    },
  },
  orderSummary: {
    title: "Order summary",
    testLabel: "Lab test",
    panelLabel: "Lab panel",
    panelTestCount: "Includes {{count}} lab test",
    panelTestCount_plural: "Includes {{count}} lab tests",
    subtotal: "Subtotal",
    taxesEstimated: "Taxes (est.)",
    taxesDeferred: "Calculated on next step",
    total: "Total",
  },
  // Blocked-state copy mirrors existing patient-facing lab messaging patterns
  // (patient `common.na` and the shared `labs.CannotOrderInState*` strings) —
  // deliberately not bespoke, per BUT-1109 scope.
  blocked: {
    unavailableLabel: "This item is not available.",
    stateRestrictedLabel: "Please contact your practitioner for next steps.",
  },
} as const;
